<template>
  <Teleport to="body">
    <ModalSmall :title="t('mobile_use')" @close="close">
      <div class="container-qr">
        <p>
          {{ t('mobile_open_guide') }}
        </p>
        <div v-if="userStore.isMobile">
          <div class="wrapper-qr-image">
            <img class="qr-image" :src="urlQrCodeAndroid" />
          </div>
          <div class="wrapper-qr-image">
            <img class="qr-image" :src="urlQrCodeIos" />
          </div>
        </div>
        <div class="wrapper-button">
          <input
            type="text"
            :value="urlDownloadAppAndroid"
            disabled
            class="copy-input"
          />
          <ButtonProcess full-width @click="copyLinkAndroid">
            {{ isCopiedAndroid ? t('copy_completed') : t('urlcopy') }}
          </ButtonProcess>
        </div>
        <div class="wrapper-button">
          <input
            type="text"
            :value="urlDownloadAppiOS"
            disabled
            class="copy-input"
          />
          <ButtonProcess full-width @click="copyLinkIos">
            {{ isCopiedIos ? t('copy_completed') : t('urlcopy') }}
          </ButtonProcess>
        </div>
      </div>
    </ModalSmall>
  </Teleport>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { useUserStore } from '@/stores/user';

import ButtonProcess from '../base/ButtonProcess.vue';


const { t } = useI18n();

const userStore = useUserStore();

const isCopiedAndroid = ref(false); // 안드로이드 어플 다운로드 링크 복사 여부
const isCopiedIos = ref(false); // 아이폰 어플 다운로드 링크 복사 여부

// TODO URL 수정
const urlDownloadAppAndroid =
  'https://play.google.com/store/apps/details?id=com.sktelecom.talkn';
const urlDownloadAppiOS = 'https://apps.apple.com/kr/app/talkn/id6446489151';
const urlQrCodeAndroid =
  'https://sconchat.blob.core.windows.net/sconchat/partner/qrcode/image/445/CONSULTATION_CALL/6rmA7KCV66-87J2YIOyghO2ZlO2GteyXrQ==.png';
const urlQrCodeIos =
  'https://sconchat.blob.core.windows.net/sconchat/partner/qrcode/image/445/CONSULTATION_CALL/6rmA7KCV66-87J2YIOyghO2ZlO2GteyXrQ==.png';

// 통역방 URL 링크
const linkUrl = computed(() => {
  return 'ANDROID';
});

// QR 코드 이미지 URL
const qrCodeUrl = computed((): string => {
  return '';
});

// 안드로이드 링크 복사
const copyLinkAndroid = async () => {
  try {
    await navigator.clipboard.writeText(urlDownloadAppAndroid);
    isCopiedAndroid.value = true;
  } catch (err) {
    console.error('복사 실패:', err);
  }
};

// 아이폰 링크 복사
const copyLinkIos = async () => {
  try {
    await navigator.clipboard.writeText(urlDownloadAppiOS);
    isCopiedAndroid.value = true;
  } catch (err) {
    console.error('복사 실패:', err);
  }
};

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};
</script>

<style scoped lang="scss">
.container-qr {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border-radius: 8px;
}

.wrapper-qr-image {
  background-color: var(--surface-gray-dimmer);
  border-radius: 8px;
  width: 10rem;
  overflow: hidden;
  display: inline-block;
}

.qr-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  mix-blend-mode: multiply;
}

.wrapper-button {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
}
</style>
